var _excluded = ["className", "color", "iconSize", "inverse", "size", "svg", "trim"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React from 'react';
import { useTheme } from 'styled-components';
import StyledSvg from "./styled";
import { getResponsiveValue } from "../../utils";
import { useInverse } from "../BackgroundProvider";
var SvgIcon = function SvgIcon(_ref) {
  var customClass = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'inherit' : _ref$color,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 'default' : _ref$iconSize,
    inverseProp = _ref.inverse,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's2' : _ref$size,
    SvgComponent = _ref.svg,
    _ref$trim = _ref.trim,
    trim = _ref$trim === void 0 ? false : _ref$trim,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var inverse = inverseProp !== undefined ? inverseProp : useInverse(theme);
  var className = classnames('csl-icon', "csl-icon--".concat(color), customClass);
  return /*#__PURE__*/React.createElement(StyledSvg, {
    $color: color,
    $iconSize: iconSize,
    $inverse: getResponsiveValue(inverse),
    $size: size,
    $trim: trim
  }, /*#__PURE__*/React.createElement(SvgComponent, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    "aria-hidden": "true",
    className: className
    // @ts-ignore
    ,
    disabled: true,
    focusable: "false"
  })));
};
SvgIcon.displayName = 'SvgIcon';
export default SvgIcon;
export { default as styledIcon } from "./styled";